export const SET_MODERATION_COUNTER = 'SET_MODERATION_COUNTER';
export const SET_PAYMENT_PENDING_COUNTER = 'SET_PAYMENT_PENDING_COUNTER';